import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { CACHE } from '../../utils/constants';
import { convertRupeeCharToUnicode, getKey, getZeroSubscriptionText } from '../../utils/common';

class Btn extends Component {
  constructor(props) {
    super(props);
    this.buttonText = 'Submit';
    const merchantConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    if (merchantConfig && merchantConfig.labels && merchantConfig.labels.pay) {
      this.buttonText = merchantConfig.labels.pay;
    }
  }

  render({ payEnabled, onBtnClick, btnText, btnSubText, subscription }) {
    let buttonText = this.buttonText;
    let subscriptionText;
    if (btnText) {
      buttonText = btnText;
    }
    /* using string fromcodepoint to convert the entity to javascript object */
    buttonText = convertRupeeCharToUnicode(buttonText);

    if (getKey(subscription, 'isEnabled', false) && buttonText.includes('PAY')) {
      subscriptionText = getZeroSubscriptionText(this.props.cache);
    }

    return (
      <div
        className={`ptm-body-bg ptm-pos-a ptm-btn-wrapper ${!payEnabled ? 'ptm-btn-disabled' : ''}`}
        id="checkout-button"
      >
        <button
          className={`ptm-custom-btn ptm-hvr-pop ${
            btnSubText || subscriptionText ? 'ptm-has-sub-text' : ''
          } ${!payEnabled ? 'ptm-disabled-btn' : ''}`}
          disabled={!payEnabled}
          onClick={onBtnClick}
        >
          {buttonText}
          {btnSubText && <span class={`ptm-d-block ptm-small-txt ptm-sub-text`}>{btnSubText}</span>}
          {subscriptionText && (
            <span className={`ptm-d-block ptm-small-txt ptm-subs-info-text`}>
              {subscriptionText}
            </span>
          )}
        </button>
      </div>
    );
  }
}

export default connect('payEnabled, btnText, cache, btnSubText, subscription')(Btn);
export const CustomButtom = connect('cache')(Btn);



// WEBPACK FOOTER //
// ./components/btn/index.js